import React, { useCallback, useEffect, useState } from "react";
import CameraTable from "./CameraTable";
import CheckedIcon from "../../images/svg/CheckedIcon.svg";
import UncheckedIcon from "../../images/svg/UncheckedIcon.svg";
import { APIUtility } from "../../Api";
import "./camera.css";
import { Search } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCameraData,
  setUserData,
} from "../../Redux/CommonSlice/allDataSlice";
import Selectbox from "../../components/Common/Selectbox";
import { addToast } from "../../Redux/CommonSlice/toastSlice";
import { Spinner } from "react-bootstrap";
import { Plus } from "lucide-react";
import { debounce } from "lodash";

const Cameras = () => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isQRCodeEnabled, setIsQRCodeEnabled] = useState(false);
  const [cameraName, setCameraName] = useState("");
  const [rtspLink, setRtspLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isTableloading, setIsTableLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [ErrorMessage, setErrorMessage] = useState(null)
  const dispatch = useDispatch();
  const users = useSelector((state) => state.data?.userData || []);
  const camtableData = useSelector((state) => state.data.cameraData);
  const auth = useSelector((state) => state.auth);
  const { permissions } = auth?.user?.user_permissions || {}






  const resetForm = () => {
    setRtspLink("");
    setCameraName("");
    setIsQRCodeEnabled(false);
    setSelectedUsers([]);
  };



  const headers = [
    "Camera Configuration",
    "CCTV RTSP Link",
    "Configured User",
    "Camera Interaction",
    "Action",
  ];
  useEffect(() => {
    if (camtableData) {
      setIsTableLoading(false);
    }
  }, [camtableData]);

  const cameraData = [];

  const fetchCamData = async () => {
    setIsTableLoading(true);
    try {
      const response = await APIUtility.GetCameraData();
      if (response.status == 200 || response.status == 201) {
        dispatch(setCameraData(response.data));
        setIsTableLoading(false);
      } else {
        setIsTableLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setIsTableLoading(false);
    }
  };
  useEffect(() => {
    fetchCamData();
    fetchUsers()
  }, [dispatch]);

  const handleSearch = useCallback(
    debounce((query) => {
      setSearchQuery(query);
    }, 300),
    []
  );

  const fetchUsers = async () => {
    try {
      const fetchUsersResponse = await APIUtility.GetUserRole();

      dispatch(setUserData(fetchUsersResponse.data));
    } catch (error) {
      dispatch(setUserData([]));
      console.error("Failed to fetch users:", error);
    }
  };

  const handleQRCodeChange = () => {
    setIsQRCodeEnabled(!isQRCodeEnabled);
  };
  function validateRTSP(value) {
    // Regular expression to validate RTSP URLs
    const rtspPattern = /^rtsp:\/\/(?:[a-zA-Z0-9._-]+(:[a-zA-Z0-9._-]+)?@)?[a-zA-Z0-9._-]+(:[0-9]+)?\/?.*$/i;
    return rtspPattern.test(value);
  }
  const handleAddCamera = async () => {

    try {
      const selectedUserIds = selectedUsers?.map((user) => {
        return user ? user.value : null;
      });

      const data = {
        name: cameraName,
        rtsp_link: rtspLink,
        user: selectedUserIds, // Use user IDs instead of usernames
        qr_code_status: isQRCodeEnabled,
      };
      if (validateRTSP(rtspLink)) {
        setIsLoading(true);
        const response = await APIUtility.AddCamera(data);
        if (response.status === 201) {
          setIsLoading(false);
          resetForm();
          fetchCamData();
          dispatch(
            addToast({ message: "Camera Added Successfully", isError: false })
          );
        } else {
          dispatch(addToast({ message: "Camera not Added", isError: true }));
          setIsLoading(false);
        }
      } else {
        setErrorMessage("Enter Valid Camera Url Or rtsp link")
        setTimeout(() => {
          setErrorMessage(null)
        }, 5000)
      }

    } catch (error) {
      console.error("Failed to add camera:", error);
      setIsLoading(false);
      dispatch(
        addToast({
          message: error.message || error.Text || "Failed to Add Camera",
          isError: true,
        })
      );
    }
  };

  return (
    <div className="p-6">
      <div className="mb-4 w-full flex justify-between">
        <div className="text-gray-400 text-lg font-semibold">
          Cameras
        </div>
      </div>
      {
        permissions?.camera_add_button && <div className="flex items-stretch mb-4 space-x-4 bg-white px-3 py-3 rounded-md">
          <div className="flex flex-col w-[227px]">
            <label className="text-black text-xs font-normal pb-1">
              Camera Configuration Name*
            </label>
            <input
              type="text"
              placeholder="eg. Main Gate"
              className="border p-2 rounded w-full h-[45px]"
              value={cameraName}
              onChange={(e) => setCameraName(e.target.value)}
            />
          </div>
          <div className="flex flex-col flex-grow">
            <label className="text-black text-xs font-normal pb-1">
              CCTV RTSP Link*
            </label>
            <input
              type="text"
              placeholder="Enter CCTV RTSP Link"
              className="border p-2 rounded w-full h-[45px]"
              value={rtspLink}
              onChange={(e) => setRtspLink(e.target.value)}
            />
            {ErrorMessage && <p className=" m-0 text-red-600 text-[10px]">{ErrorMessage}</p>}
          </div>
          <div className="user-select flex flex-col w-[250px]">
            <label className="text-black text-xs font-normal pb-1">
              User Configuration
            </label>
            <Selectbox
              placeholder="Select User to Configure"
              containerClass="!w-full z-50"
              data={Array.isArray(users) ? users?.map((item) => ({
                label: item.username,
                value: item.id,
              })) : []}
              onSelect={(value) => {
                setSelectedUsers(value);
              }}
              defaultValue={selectedUsers}
              multiselect
              checkbox
            />
          </div>
          <div className="pt-3 flex flex-wrap gap-3">
            <button
              className="p-2 mt-1 flex items-center text-green-500 border-2 border-green-500 w-[175px]"
              onClick={handleQRCodeChange}
            >
              <img
                src={isQRCodeEnabled ? CheckedIcon : UncheckedIcon}
                alt="QR Code Icon"
                className="h-6 w-6 mr-2"
              />
              <span>Enable QR Code</span>
            </button>
            <button
              className={`border mt-1 p-2 rounded-[3px] text-white w-[149px] ${!cameraName || !rtspLink || selectedUsers.length === 0
                  ? "bg-gray-300"
                  : "bg-green-500"
                }`}
              onClick={handleAddCamera}
              disabled={!cameraName || !rtspLink || selectedUsers.length === 0}
            >
              {isLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>{" "}
                  Adding...
                </div>
              ) : (
                <div className="flex items-center gap-2">
                  <Plus color="#FFFFFF" />
                  <span>Add Camera</span>
                </div>
              )}
            </button>
          </div>
        </div>
      }

      <div className="flex items-center mb-2.5">
        <div className="relative flex items-center">
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 pointer-events-none"
            color="#999999"
          />
          <input
            type="text"
            placeholder="Search by Camera Configuration"
            className="pl-10 pr-4 py-2 border rounded w-[415px] h-[45px]"
            style={{ paddingLeft: "2.5rem" }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="overflow-x-auto h-table_h_370">
        <CameraTable
          headers={headers}
          cameraData={cameraData}
          users={users}
          fetchCamData={fetchCamData}
          isTableloading={isTableloading}
          searchQuery={searchQuery}
          validateRTSP={validateRTSP}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

export default Cameras;
